/* Dogs Supreme - PDP Zoom 2026 (custom, ersetzt die alte PhotoSwipe-Lightbox).
 * Desktop: Hi-Res Hover-Lupe direkt im Bild (kein Button, kein Chrome).
 * Klick/Tap: cleanes Vollbild mit Pinch/Doppeltipp-Zoom, Pan, Wisch-nach-unten-schliessen, Wisch-Navigation.
 * Liest die vorhandene 2560er-Quelle aus data-photoswipe-src. Kein Fremd-Lib.
 * Greift NICHT in Flickity/theme.js ein (nur additive Listener + eigenes Overlay).
 */
(function () {
  "use strict";
  if (window.__dsZoom2026) return;
  window.__dsZoom2026 = true;

  var FINE = window.matchMedia("(hover:hover) and (pointer:fine)").matches;
  var LENS = 2.5;

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }

  function hires(img) {
    if (!img) return "";
    var s = img.getAttribute("data-photoswipe-src");
    if (s) { if (s.indexOf("//") === 0) s = "https:" + s; return s; }
    return img.currentSrc || img.src || "";
  }

  function init() {
    var gallery = document.querySelector("[data-product-images]");
    if (!gallery) return;

    var imgsOf = function () {
      return [].slice.call(gallery.querySelectorAll(".product-main-slide img")).filter(Boolean);
    };
    // Nur die relevanten Bilder ins Vollbild: aktuelle Variantenfarbe + farblose geteilte Bilder (Lifestyle/Infografik).
    // Farb-Studioshots folgen dem Muster hundegeschirr-<farbe>-dogs-supreme; alles andere gilt als geteilt.
    function colorOf(src) { var m = (src || "").match(/hundegeschirr-([a-z0-9-]+?)-dogs-supreme/i); return m ? m[1].toLowerCase() : null; }
    function relevantImgs() {
      var all = imgsOf();
      var sel = gallery.querySelector(".product-main-slide.is-selected") || gallery.querySelector(".product-main-slide.starting-slide");
      var selImg = sel && sel.querySelector("img");
      var cur = selImg ? colorOf(selImg.getAttribute("data-photoswipe-src")) : null;
      if (cur == null) return all;
      var filtered = all.filter(function (im) { var c = colorOf(im.getAttribute("data-photoswipe-src")); return c === null || c === cur; });
      return filtered.length ? filtered : all;
    }

    /* ---------- Desktop: Hi-Res Hover-Lupe ---------- */
    if (FINE) {
      [].slice.call(gallery.querySelectorAll(".product-image-main")).forEach(function (frame) {
        var img = frame.querySelector("img");
        if (!img) return;
        frame.classList.add("ds-zoomable");
        var lens = document.createElement("div");
        lens.className = "ds-zoom-lens";
        frame.appendChild(lens);
        var on = false;
        frame.addEventListener("pointerenter", function (e) {
          if (e.pointerType && e.pointerType !== "mouse") return;
          lens.style.backgroundImage = 'url("' + hires(img) + '")';
          on = true; lens.style.opacity = "1"; move(e);
        });
        frame.addEventListener("pointermove", function (e) { if (on) move(e); });
        frame.addEventListener("pointerleave", function () { on = false; lens.style.opacity = "0"; });
        function move(e) {
          var r = frame.getBoundingClientRect();
          var rx = Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
          var ry = Math.min(1, Math.max(0, (e.clientY - r.top) / r.height));
          var bw = r.width * LENS, bh = r.height * LENS;
          lens.style.backgroundSize = bw + "px " + bh + "px";
          lens.style.backgroundPosition = (-(rx * (bw - r.width))) + "px " + (-(ry * (bh - r.height))) + "px";
        }
      });
    }

    /* ---------- Tap/Klick -> Vollbild (Drag von Flickity ausgeschlossen) ---------- */
    [].slice.call(gallery.querySelectorAll(".product-main-slide")).forEach(function (slide) {
      var down = null;
      slide.addEventListener("pointerdown", function (e) { down = { x: e.clientX, y: e.clientY, t: Date.now() }; });
      slide.addEventListener("pointerup", function (e) {
        if (!down) return;
        var dx = e.clientX - down.x, dy = e.clientY - down.y;
        if (Math.hypot(dx, dy) < 8 && Date.now() - down.t < 500) {
          var imgs = relevantImgs();
          var i = imgs.indexOf(slide.querySelector("img"));
          V.open(imgs.map(hires), i < 0 ? 0 : i);
        }
        down = null;
      });
    });

    buildViewer();
  }

  /* ---------- Vollbild-Viewer ---------- */
  var V = {}, el = {}, scale = 1, tx = 0, ty = 0, open_ = false, srcs = [], idx = 0;
  var pointers = new Map(), startDist = 0, startScale = 1, startTx = 0, startTy = 0;
  var dragStart = null, moved = false, swipeAxis = null, lastTap = 0;

  function buildViewer() {
    var v = document.createElement("div");
    v.className = "dsz-viewer";
    v.setAttribute("aria-hidden", "true");
    v.innerHTML =
      '<button class="dsz-close" aria-label="Schliessen"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<img class="dsz-img" alt="">' +
      '<div class="dsz-dots"></div>';
    document.body.appendChild(v);
    el.v = v; el.img = v.querySelector(".dsz-img"); el.dots = v.querySelector(".dsz-dots");
    v.querySelector(".dsz-close").addEventListener("click", function (e) { e.stopPropagation(); V.close(); });

    v.addEventListener("wheel", function (e) { if (!open_) return; e.preventDefault(); zoomAt(e.clientX, e.clientY, scale * (e.deltaY < 0 ? 1.18 : 0.85)); }, { passive: false });
    v.addEventListener("dblclick", function (e) { zoomAt(e.clientX, e.clientY, scale > 1.01 ? 1 : 2.5); });
    v.addEventListener("pointerdown", pDown);
    v.addEventListener("pointermove", pMove);
    v.addEventListener("pointerup", pUp);
    v.addEventListener("pointercancel", pUp);
    window.addEventListener("keydown", function (e) {
      if (!open_) return;
      if (e.key === "Escape") V.close();
      else if (e.key === "ArrowRight") swap((idx + 1) % srcs.length, 1);
      else if (e.key === "ArrowLeft") swap((idx - 1 + srcs.length) % srcs.length, -1);
    });
  }

  function renderDots() {
    el.dots.textContent = srcs.length > 1 ? (idx + 1) + " / " + srcs.length : "";
  }
  function apply(anim) { el.img.classList.toggle("dragging", !anim); el.img.style.transform = "translate(calc(-50% + " + tx + "px),calc(-50% + " + ty + "px)) scale(" + scale + ")"; }
  function zoomedClass() { el.v.classList.toggle("zoomed", scale > 1.01); }
  function clampPan() {
    var maxX = Math.max(0, (el.img.clientWidth * scale) - window.innerWidth) / 2 + 40;
    var maxY = Math.max(0, (el.img.clientHeight * scale) - window.innerHeight) / 2 + 40;
    tx = Math.max(-maxX, Math.min(maxX, tx)); ty = Math.max(-maxY, Math.min(maxY, ty));
  }
  function zoomAt(cx, cy, ns) {
    ns = Math.max(1, Math.min(5, ns));
    var r = el.img.getBoundingClientRect(), px = cx - (r.left + r.width / 2), py = cy - (r.top + r.height / 2), k = ns / scale;
    tx -= px * (k - 1); ty -= py * (k - 1); scale = ns;
    if (scale <= 1.01) { scale = 1; tx = 0; ty = 0; }
    clampPan(); zoomedClass(); apply(true);
  }

  V.open = function (list, i) {
    srcs = list; idx = i; scale = 1; tx = 0; ty = 0;
    el.img.src = srcs[i]; renderDots();
    el.v.classList.add("on"); el.v.setAttribute("aria-hidden", "false");
    document.body.style.overflow = "hidden";
    void el.v.offsetWidth;
    setTimeout(function () { el.v.classList.add("in"); apply(true); }, 20);
    open_ = true; zoomedClass();
  };
  V.close = function () {
    open_ = false; el.v.classList.remove("in"); el.v.style.background = ""; el.img.style.opacity = "";
    setTimeout(function () { el.v.classList.remove("on"); el.v.setAttribute("aria-hidden", "true"); document.body.style.overflow = ""; scale = 1; tx = 0; ty = 0; apply(true); zoomedClass(); }, 330);
  };

  function pDown(e) {
    if (!open_) return;
    try { el.v.setPointerCapture(e.pointerId); } catch (x) {}
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pointers.size === 2) {
      var p = Array.from(pointers.values());
      startDist = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      startScale = scale; startTx = tx; startTy = ty;
    } else {
      dragStart = { x: e.clientX, y: e.clientY, tx: tx, ty: ty }; moved = false; swipeAxis = null;
      var now = Date.now();
      if (now - lastTap < 300) { zoomAt(e.clientX, e.clientY, scale > 1.01 ? 1 : 2.5); lastTap = 0; } else lastTap = now;
    }
  }
  function pMove(e) {
    if (!open_ || !pointers.has(e.pointerId)) return;
    pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
    if (pointers.size === 2) {
      var p = Array.from(pointers.values());
      var dist = Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y);
      var ns = Math.max(1, Math.min(5, startScale * (dist / startDist)));
      tx = startTx; ty = startTy; scale = ns;
      if (scale <= 1.01) { scale = 1; tx = 0; ty = 0; }
      clampPan(); zoomedClass(); apply(false); return;
    }
    if (!dragStart) return;
    var dx = e.clientX - dragStart.x, dy = e.clientY - dragStart.y;
    if (!moved && Math.hypot(dx, dy) > 6) moved = true;
    if (scale > 1.01) { tx = dragStart.tx + dx; ty = dragStart.ty + dy; clampPan(); apply(false); }
    else {
      if (!swipeAxis && Math.hypot(dx, dy) > 10) swipeAxis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
      if (swipeAxis === "y" && dy > 0) { ty = dy; el.img.style.opacity = Math.max(0.2, 1 - dy / 500); el.v.style.background = "rgba(0,0,0," + Math.max(0.4, 0.95 - dy / 700) + ")"; apply(false); }
      else if (swipeAxis === "x") { tx = dx; apply(false); }
    }
  }
  function pUp(e) {
    if (!open_) return;
    pointers.delete(e.pointerId);
    if (pointers.size === 1) { var p = Array.from(pointers.values())[0]; dragStart = { x: p.x, y: p.y, tx: tx, ty: ty }; return; }
    if (pointers.size > 0) return;
    if (scale <= 1.01) {
      if (swipeAxis === "y" && ty > 110) { V.close(); return; }
      if (swipeAxis === "x" && Math.abs(tx) > 90) { var dir = tx < 0 ? 1 : -1; swap((idx + dir + srcs.length) % srcs.length, dir); return; }
      ty = 0; tx = 0; el.img.style.opacity = ""; el.v.style.background = ""; apply(true);
      if (!moved) {
        var r = el.img.getBoundingClientRect();
        if (e.clientX < r.left || e.clientX > r.right || e.clientY < r.top || e.clientY > r.bottom) V.close();
      }
    }
    swipeAxis = null; dragStart = null;
  }
  function swap(ni, dir) {
    el.img.style.transition = "transform .2s ease,opacity .2s ease";
    tx = dir * -window.innerWidth; el.img.style.opacity = "0"; apply(true);
    setTimeout(function () {
      idx = ni; el.img.src = srcs[ni]; renderDots(); scale = 1; tx = dir * window.innerWidth; ty = 0;
      el.img.classList.add("dragging"); apply(false); void el.img.offsetWidth;
      el.img.classList.remove("dragging"); el.img.style.opacity = "1"; tx = 0; apply(true);
      setTimeout(function () { el.img.style.transition = ""; }, 220);
    }, 200);
  }

  function injectStyles() {
    var css =
      ".product-image-main.ds-zoomable{position:relative;cursor:zoom-in}" +
      ".ds-zoom-lens{position:absolute;inset:0;z-index:3;pointer-events:none;opacity:0;transition:opacity .16s ease;background-repeat:no-repeat;border-radius:inherit}" +
      "@media (hover:none){.ds-zoom-lens{display:none}}" +
      ".dsz-viewer{position:fixed;inset:0;z-index:99999;display:none;background:rgba(0,0,0,0);-webkit-backdrop-filter:blur(0);backdrop-filter:blur(0);transition:background .32s ease,backdrop-filter .32s ease;touch-action:none;overscroll-behavior:contain}" +
      ".dsz-viewer.on{display:block}" +
      ".dsz-viewer.in{background:rgba(0,0,0,.98);-webkit-backdrop-filter:blur(3px);backdrop-filter:blur(3px)}" +
      ".dsz-img{position:absolute;left:50%;top:50%;max-width:100vw;max-height:100vh;transform:translate(-50%,-50%) scale(.9);opacity:0;transition:transform .34s cubic-bezier(.2,.7,.2,1),opacity .34s ease;will-change:transform,opacity;user-select:none;-webkit-user-drag:none}" +
      ".dsz-viewer.in .dsz-img{opacity:1}" +
      ".dsz-img.dragging{transition:none}" +
      ".dsz-viewer.zoomed{cursor:grab}" +
      ".dsz-close{position:absolute;top:15px;right:15px;width:36px;height:36px;border:none;border-radius:50%;background:rgba(255,255,255,.14);color:#fff;cursor:pointer;z-index:2;display:flex;align-items:center;justify-content:center;opacity:0;transition:opacity .3s,background .2s;-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px)}" +
      ".dsz-viewer.in .dsz-close{opacity:.9}" +
      ".dsz-close:hover{background:rgba(255,255,255,.26)}.dsz-close svg{width:16px;height:16px}" +
      ".dsz-dots{position:absolute;left:50%;bottom:20px;transform:translateX(-50%);z-index:2;opacity:0;transition:opacity .3s;font:500 13px/1 -apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;color:rgba(255,255,255,.92);background:rgba(255,255,255,.12);padding:6px 12px;border-radius:100px;-webkit-backdrop-filter:blur(8px);backdrop-filter:blur(8px);font-variant-numeric:tabular-nums;letter-spacing:.02em}" +
      ".dsz-dots:empty{display:none}" +
      ".dsz-viewer.in .dsz-dots{opacity:.9}" +
      "@media (prefers-reduced-motion:reduce){.dsz-viewer,.dsz-img,.ds-zoom-lens{transition:none}}";
    var st = document.createElement("style"); st.setAttribute("data-ds-zoom", ""); st.textContent = css;
    document.head.appendChild(st);
  }

  injectStyles();
  ready(init);
})();
